export function determineMaestroEventLocation(location) {
  if (typeof location !== 'string') {
    return null;
  }
  return location.toUpperCase();
}

export function determineHHPModelEventLocation(thing) {
  if (typeof thing !== 'string') {
    return null;
  }
  if (/nbl|ecs/.test(thing)) {
    return 'NBL';
  }
  if (/argos|sseo/.test(thing)) {
    return 'ARGOS';
  }
  if (/chapea|uia/.test(thing)) {
    return 'CHAPEA';
  }
  if (/drats|hrm-argos/.test(thing)) {
    return 'FIELDTEST';
  }
  if (thing === 'hippo-uploader') {
    return 'UPLOADS';
  }
  return null;
}

export const pico2ReferenceAreas = [
  {
    fill: '#A7ADB6',
    fillOpacity: 0,
    y1: 15,
    y2: 16,
    timeRemaining: 0,
    legendValue: '> 15',
    piCO2totalsKey: 'gt15',
  },
  {
    fill: '#69707C',
    fillOpacity: 0.2,
    y1: 12.5,
    y2: 15,
    timeRemaining: 0.5 * 3600 * 1000,
    legendValue: '≤ 15',
    piCO2totalsKey: 'leq15',
  },
  {
    fill: '#69707C',
    fillOpacity: 0.15,
    y1: 10,
    y2: 12.4,
    timeRemaining: 3600 * 1000,
    legendValue: '≤ 12.5',
    piCO2totalsKey: 'leq12_5',
  },
  {
    fill: '#A7ADB6',
    fillOpacity: 0.15,
    y1: 7,
    y2: 9.9,
    timeRemaining: 2.5 * 3600 * 1000,
    legendValue: '≤ 10',
    piCO2totalsKey: 'leq10',
  },
  {
    fill: '#A7ADB6',
    fillOpacity: 0.07,
    y1: 4,
    y2: 7,
    timeRemaining: 7.0 * 3600 * 1000,
    legendValue: '≤ 7',
    piCO2totalsKey: 'leq7',
  },
  {
    fill: '#A7ADB6',
    fillOpacity: 0,
    y1: 0,
    y2: 4,
    legendValue: '≤ 4',
    piCO2totalsKey: 'leq4',
  },
];

export default { determineMaestroEventLocation, determineHHPModelEventLocation, pico2ReferenceAreas };
